module.exports = __webpack_public_path__ + "img/GB-ENG.4628c885.svg";